import React from 'react'
import EmployeeDashboard from './EmployeeDashboard';
import AdminDashboard from './AdminDashboard';

export const Dashboard = () => {
    const check = JSON.parse(localStorage.getItem("edetails"))?.rId == 1;
    return (
        check ? <AdminDashboard /> : <EmployeeDashboard />
    )
}